import { Link } from "react-router-dom";
import backFlourish from "../assets/images/icons/back-flourish.svg";
import Brand from "../components/Brand";
import { RoomId, useTranslation } from "../components/Localization";

const rooms: RoomId[] = ["residence", "dining", "mirror", "salon", "estate", "legacy", "war"];

export default function OverviewPage() {
  const { room, t } = useTranslation();
  return (
    <main className="screen overview">
      <div className="overview-content">
        <Brand />
        <div className="overview-list-scroll">
          <div className="overview-list">
            {rooms.map((roomId) => (
              <div className="outline-button" key={roomId}>
                {room(roomId)?.name}
              </div>
            ))}
          </div>
        </div>
        <footer className="overview-footer">
          <Link className="overview-back" to="/" aria-label={t("common.back")}>
            <img src={backFlourish} alt="" />
          </Link>
        </footer>
      </div>
    </main>
  );
}
